export type EmbedPermissionType = 'VIEW' | 'EDIT' | 'DELETE'

export interface EmbedPermissions {
  canView: boolean
  canEdit: boolean
  canDelete: boolean
}

const DEFAULT_EMBED_PERMISSIONS: EmbedPermissions = {
  canView: true,
  canEdit: true,
  canDelete: true,
}

export function parseEmbedPermissions(
  params: Record<string, unknown>,
): EmbedPermissions {
  const rawPermissions = params['permissions']
  const serializedPermissions = Array.isArray(rawPermissions)
    ? rawPermissions[0]
    : rawPermissions

  if (typeof serializedPermissions !== 'string' || !serializedPermissions) {
    return { ...DEFAULT_EMBED_PERMISSIONS }
  }

  try {
    const parsed = JSON.parse(serializedPermissions) as Partial<
      Record<EmbedPermissionType, boolean>
    >

    return {
      canView: parsed.VIEW ?? DEFAULT_EMBED_PERMISSIONS.canView,
      canEdit: parsed.EDIT ?? DEFAULT_EMBED_PERMISSIONS.canEdit,
      canDelete: parsed.DELETE ?? DEFAULT_EMBED_PERMISSIONS.canDelete,
    }
  } catch (error) {
    console.warn(
      '[embed][permissions] failed to parse permissions query param',
      error,
    )

    return { ...DEFAULT_EMBED_PERMISSIONS }
  }
}
